<template>
  <div class="page-header">
    <div>
      <div class="container-fluid">
        <h1>
          <slot name="title"></slot>
        </h1>
        <h2>
          <slot name="subtitle"></slot>
        </h2>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
@import "src/scss/component-helpers";

.page-header {
  position: relative;
  color: #000000;
  padding-top: 6rem;

  .background-overlay {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .container-fluid {
      align-content: center;

      @media (max-width: map_get($grid-breakpoints, 'xxl')) {
        padding-top: 2rem;
        padding-bottom: 2rem;
      }

      @media (min-width: map_get($grid-breakpoints, 'xxl')) {
        height: 15.625rem;
      }
    }
  }

  h1 {
    @include poppins(48, 700);
  }

  h2 {
    @include poppins(48, 300);
  }
}
</style>
